// App Bridge v4+ provides a global 'shopify' variable (lowercase)
// It auto-initializes via the CDN script—no need to manually call createApp()
// The navigation menu is rendered as a web component in app/views/layouts/_shopify_embedded_app.html.slim
// This script's main purpose is to obtain the session token and attach it to all requests and forms

document.addEventListener('turbolinks:request-start', function (event) {
  if (window.sessionToken) {
    const xhr = event.data.xhr
    xhr.setRequestHeader('Authorization', 'Bearer ' + window.sessionToken)
  }
})

jQuery(document).on('turbolinks:load', async function() {
  if (window.shopify) {
    try {
      await retrieveToken()
      keepRetrievingToken()
    } catch (error) {
      console.error('[AppBridge] Error getting session token:', error)
    }
  }
})

jQuery(document).on('turbolinks:load', function() {
  if (window.shopify && window.sessionToken && isSafari()) {
    $('form').on('submit', function(event) {
      event.preventDefault();
      event.stopPropagation();

      const form = $(this);
      const formData = new FormData(form[0]);

      if ($('#store_logo').length) {
        formData.append('logo', $('#store_logo').prop('files')[0]);
      }

      $.ajax({
        url: form.attr('action'),
        method: form.attr('method'),
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: function(xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + window.sessionToken)
        },
        success: function(data) {
          hc_toast('Changes saved', 'success')
        },
        error: function(data) {
          hc_toast('There was an error while submitting data. Please try again', 'error')
        }
      });
    });

    $("a[data-remote='true']").on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      $.ajax({
        url: $(this).attr('href'),
        method: $(this).data().method || 'POST',
        dataType: $(this).data().datatype || '',
        beforeSend: function(xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + window.sessionToken)
        },
      });
    });
  }
});

async function retrieveToken() {
  try {
    // Modern App Bridge: use idToken() method to get session token
    window.sessionToken = await window.shopify.idToken()
  } catch (error) {
    console.error('[AppBridge] Error retrieving token:', error)
  }
}

function keepRetrievingToken() {
  setInterval(() => {
    retrieveToken()
  }, 2000)
}

function isSafari() {
  return /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent);
}
